// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetAlarmLatchedRequest
 */
export interface SetAlarmLatchedRequest {
    /**
     * 
     */
    latched: boolean;
}

/**
 * Check if a given object implements the SetAlarmLatchedRequest interface.
 */
export function instanceOfSetAlarmLatchedRequest(value: object): value is SetAlarmLatchedRequest {
    if (!('latched' in value) || value['latched'] === undefined) return false;
    return true;
}

export function SetAlarmLatchedRequestFromJSON(json: any): SetAlarmLatchedRequest {
    return SetAlarmLatchedRequestFromJSONTyped(json, false);
}

export function SetAlarmLatchedRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetAlarmLatchedRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'latched': json['latched'],
    };
}

export function SetAlarmLatchedRequestToJSON(json: any): SetAlarmLatchedRequest {
    return SetAlarmLatchedRequestToJSONTyped(json, false);
}

export function SetAlarmLatchedRequestToJSONTyped(value?: SetAlarmLatchedRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latched': value['latched'],
    };
}

